import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Plus as PlusIcon } from '@bibliocommons/deprecated-base-icons';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';

import { allowFreeText } from 'app/helpers/user';
import './AddButton.scss';

export default function AddButton({ owner, handleClick, screenReaderMessage }) {
  if (owner.get('loggedIn') && allowFreeText(owner)) {
    return (
      <TextButton className="cp-ugc-add-button" handleClick={handleClick}>
        <span aria-hidden>
          <PlusIcon />
          <FormattedMessage id="button_add" />
        </span>
        <ScreenReaderMessage>{screenReaderMessage}</ScreenReaderMessage>
      </TextButton>
    );
  }

  return null;
}

AddButton.propTypes = {
  owner: userIdentityShape.isRequired,
  handleClick: PropTypes.func.isRequired,
  screenReaderMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
};
